<template lang="pug">
  aside#cart.pointer-events-auto(v-if="checkout")
    //- cart btn
    button.flex.items-center.text-15.lg-text-13.cursor-pointer.pointer-events-auto.px-10.-mr-10.md-px-0.md-mx-0(v-show="total", @click="cart = !cart", aria-label="Toggle Cart")
      //- (label)
      span.pt-2.hidden.md-block.mr-8 Bag
      //- counter / mbl button
      .h-40.w-40.lg-h-24.lg-w-24.border.rounded-full.border-current.flex.items-center.justify-center.overflow-hidden.pt-px.text-app-accent.bg-gray-100(:class="{'md-bg-transp lg-text-white': ui === 'white'}") {{total}}

    //- OVERLAY
    transition(name="overlaymenu", @after-enter="lockScroll(true)", @before-leave="lockScroll(false)")
      overlay-menu.fixed.z-60.text-black(ref="cart", v-show="cart", @close="cart = false", bg="bg-gray-100")
        //- header
        header.pt-120.px-15.text-center.mb-50.md-mb-120.lg-absolute.w-full.top-0.left-0
          h3.text-18.md-text-24 {{ total ? 'Your Order Details' : 'Your Bag is Empty' }}
        //- body
        .flex.flex-col.lg-flex-row.lg-justify-between(v-if="total")
          //- scrolling items
          ul.lg-w-2x3.lg-pt-275
            cart-item.mb-82.md-mb-100(v-for="item in checkout.lineItems", :item="item", :key="item.id")
          //- lg-sticky summary (right column)
          footer.w-full.lg-flex-1.lg-sticky.top-0.right-0.lg-h-screen.lg-flex.items-center.justify-center.lg-ml-5pct.lg-border-l.lg-border-app-border.pt-40.pb-ios.lg-py-40
            .text-center.max-w-300.px-40.box-content.mx-auto
              //- sub-total
              //- do not use TOTALPRICE so you can fudge the VAT...
              //- if customer entered shipping in checkout already, it will apply the VAT to TOTALPRICE
              h3.text-18.md-text-17.mb-24.md-mb-20 Total {{ price(checkout.subtotalPriceV2.amount) }}
              wp-rich-text.mb-20.md-mb-30.text-11.md-text-13(:html="info")
              //- checkout btn
              a.block.w-full.btn-theme-black(:href="checkout.webUrl", target="_blank", rel="noopener noreferrer")
                btn.w-full(theme="inherit") Checkout
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import CartItem from './CartItem'
export default {
  name: 'Cart',
  components: { CartItem },
  data () {
    return {
      cart: false
    }
  },
  computed: {
    ...mapState({
      info: state => state.site && state.site.hostem_product_fine_print,
      checkout: state => state.shop.checkout,
      ui: state => state.ui
    }),
    ...mapGetters({ total: 'shop/cartTotal', price: 'shop/price' })
  },
  methods: {
    ...mapMutations(['lockScroll']),
    toggleCart () {
      this.cart = !this.cart
      if (!this.cart) this.$refs.cart.focus()
    },
    refreshCart () {
      this.$store.dispatch('shop/fetchCheckout')
    }
  },
  watch: {
    cart (vis) {
      const query = this.$route.query
      const hashd = this.$route.hash === '#cart'
      if (vis && !hashd) {
        this.$router.replace({ hash: 'cart', query: query })
      } else if (!vis && hashd && query) {
        this.$router.replace({ query })
      }
    },
    checkout (is, was) {
      if (was === null && this.$route.hash === '#cart') {
        this.cart = true
      }
    }
  },
  mounted () {
    // check to see if cart was completed...
    window.addEventListener('focus', this.refreshCart)
  },
  destroyed () {
    window.removeEventListener('focus', this.refreshCart)
  }
}
</script>

<style>
</style>
